import React, { useState } from "react";
import { useTheme } from "../context/ThemeContext";
import { useAuth } from "../context/AuthContext";
import "./ProfilePage.css";

const educationLevels = ["Undergraduate", "12th", "10th", "Postgraduate", "Schooling", "PhD"];

export default function ProfilePage({ nav }) {
  const { t } = useTheme();
  const { user, updateProfile } = useAuth();
  const [instituteName, setInstituteName] = useState(user?.instituteName || "");
  const [educationLevel, setEducationLevel] = useState(user?.educationLevel || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  if (!user) {
    nav("login");
    return null;
  }

  const saveProfile = async (event) => {
    event.preventDefault();
    setSaving(true);
    setSaved(false);
    setError("");
    try {
      await updateProfile(instituteName.trim(), educationLevel);
      setSaved(true);
    } catch (err) {
      setError(err.message || "Unable to update profile.");
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    height: 46,
    padding: "0 14px",
    border: `1px solid ${t.border2}`,
    borderRadius: 8,
    background: t.inputBg,
    color: t.text,
    font: "inherit",
    fontSize: 14,
    outline: "none",
  };

  return (
    <section className="profile-page" style={{ "--profile-bg": t.bg }}>
      <div style={{ maxWidth: 860, margin: "0 auto" }}>
        <button onClick={() => nav("home")} style={{ border: "none", background: "none", padding: 0, color: t.text2, cursor: "pointer", fontSize: 13, marginBottom: 24 }}>
          Back to archive
        </button>

        <div style={{ background: t.cardBg, border: `1px solid ${t.border}`, borderRadius: 16, overflow: "hidden", boxShadow: "0 10px 35px rgba(20, 20, 22, 0.07)" }}>
          <div className="profile-card-header" style={{ paddingTop: 32, paddingBottom: 28, background: t.primary, color: t.primaryFg }}>
            <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
              <div style={{ width: 72, height: 72, borderRadius: "50%", background: user.avatar ? "transparent" : t.cardBg, color: t.primary, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0, border: `3px solid ${t.primaryFg}` }}>
                {user.avatar
                  ? <img src={user.avatar} alt={user.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  : <span style={{ fontSize: 28, fontWeight: 700 }}>{user.name.charAt(0).toUpperCase()}</span>}
              </div>
              <div>
                <p style={{ margin: "0 0 5px", fontSize: 12, letterSpacing: "0.08em", opacity: 0.75 }}>YOUR PROFILE</p>
                <h1 style={{ margin: 0, fontSize: 28, lineHeight: 1.15 }}>{user.name}</h1>
                <p style={{ margin: "7px 0 0", fontSize: 13, opacity: 0.8 }}>{user.email}</p>
              </div>
            </div>
          </div>

          <div className="profile-card-content" style={{ paddingTop: 28, paddingBottom: 36 }}>
            <div className="profile-stats-grid" style={{ gap: 12, marginBottom: 30 }}>
              <div style={{ padding: "16px 18px", border: `1px solid ${t.border}`, borderRadius: 10 }}>
                <p style={{ margin: 0, color: t.text3, fontSize: 11, letterSpacing: "0.06em" }}>POTD SOLVED</p>
                <p style={{ margin: "7px 0 0", color: t.text, fontSize: 25, fontWeight: 700 }}>{user.potdSolvedCount || 0}</p>
              </div>
              <div style={{ padding: "16px 18px", border: `1px solid ${t.border}`, borderRadius: 10 }}>
                <p style={{ margin: 0, color: t.text3, fontSize: 11, letterSpacing: "0.06em" }}>POINTS</p>
                <p style={{ margin: "7px 0 0", color: t.text, fontSize: 25, fontWeight: 700 }}>{user.points || 0}</p>
              </div>
            </div>

            <form onSubmit={saveProfile}>
              <h2 style={{ margin: "0 0 20px", color: t.text, fontSize: 18 }}>Edit profile</h2>
              <div className="profile-form-grid" style={{ gap: 18 }}>
                <label style={{ color: t.text2, fontSize: 12, fontWeight: 600 }}>
                  INSTITUTE NAME
                  <input value={instituteName} onChange={(event) => setInstituteName(event.target.value)} maxLength={120} placeholder="Your institute or university" style={{ ...inputStyle, marginTop: 8 }} />
                </label>
                <label style={{ color: t.text2, fontSize: 12, fontWeight: 600 }}>
                  EDUCATION LEVEL
                  <select value={educationLevel} onChange={(event) => setEducationLevel(event.target.value)} style={{ ...inputStyle, marginTop: 8 }}>
                    <option value="">Select your level</option>
                    {educationLevels.map((level) => <option key={level} value={level}>{level}</option>)}
                  </select>
                </label>
              </div>
              {error && <p style={{ color: "#c0392b", fontSize: 13, margin: "16px 0 0" }}>{error}</p>}
              {saved && <p style={{ color: "#277a55", fontSize: 13, margin: "16px 0 0" }}>Profile updated successfully.</p>}
              <button type="submit" disabled={saving} style={{ marginTop: 24, minWidth: 132, height: 44, border: "none", borderRadius: 8, background: saving ? t.bg2 : t.primary, color: saving ? t.text3 : t.primaryFg, fontSize: 14, fontWeight: 600, cursor: saving ? "wait" : "pointer" }}>
                {saving ? "Updating..." : "Update profile"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
